<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'LIB_ORDERS.COMMON.ORDERS.PRICING' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <store-order-summary
      [orderItems]="orderItems"
      [taxOptions]="taxOptions"
      [duration]="duration"
      [partnerId]="partnerId"
      [marketId]="marketId"
    ></store-order-summary>
  </mat-card-content>
</mat-card>
